import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Section from '@latitude/section';
import SvgInline from '@latitude/svg-inline';
import { Typography } from '../Typography';
import './_feature_grid.scss';

const FeatureGrid = ({ title, description, features = [], maxCols = 4 }) => {
  return (
    <div className="feature-grid">
      <Section className="feature-grid__section">
        {title && (
          <Typography.H4 className="feature-grid__title">{title}</Typography.H4>
        )}
        {description && (
          <p className="feature-grid__description">{ReactHtmlParser(description)}</p>
        )}
        <div
          className="feature-grid__inner"
          role="list"
          style={{ gridTemplateColumns: `repeat(${maxCols}, 1fr)` }}
        >
          {features.map((feature, idx) => (
            <div key={idx} className="feature-grid__item" role="listitem">
              {feature.icon && (
                <SvgInline className="feature-grid__icon" name={feature.icon} />
              )}
              {feature.text && (
                <Typography.BODY className="feature-grid__text">
                  {feature.text}
                </Typography.BODY>
              )}
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
};

export default FeatureGrid;
